import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import styles from './InfinityScrollWrapper.module.scss';

interface InfinityScrollWrapperProps {
    dataLength: number;
    hasMore: boolean;
    onLoadMore: () => void;
    loading?: boolean;
    height?: number | string;
    scrollableId?: string;
    loaderText?: string;
    endMessageText?: string;
    children: React.ReactNode;
}

export default function InfinityScrollWrapper({
    dataLength,
    hasMore,
    onLoadMore,
    loading = false,
    height = 600,
    scrollableId = "infinite-scroll-container",
    loaderText = "Loading more...",
    endMessageText = "All items loaded",
    children,
}: InfinityScrollWrapperProps) {
    return (
        <div
            id={scrollableId}
            style={{ height, overflowY: "auto" }}
        >
            <InfiniteScroll
                dataLength={dataLength}
                next={onLoadMore}
                hasMore={hasMore}
                loader={
                    <div className={styles.loaderMessage}>
                        {loaderText}
                    </div>
                }
                endMessage={
                    !loading && dataLength > 0 ? (
                        <div className={styles.emptyMessage}>
                            {endMessageText}
                        </div>
                    ) : null
                }
                scrollableTarget={scrollableId}
            >
                {children}
            </InfiniteScroll>
        </div>
    );
}